import { apiPost, apiPostNoContent } from './client';

export interface Employee {
  id: string;
  givenName?: string;
  familyName?: string;
  patronymic?: string;
  avatarUrl?: string;
  email?: string;
  /** Эффективная роль в миниаппе (manager, employee; отображение administrator — с бэка при необходимости). */
  miniappRole?: string;
  /** Администратор компании в основной системе — роль в миниаппе не редактируется. */
  isCompanyAdmin?: boolean;
}

export interface FindEmployeesParams {
  search?: string;
  page?: number;
  itemsPerPage?: number;
}

export interface FindEmployeesResponse {
  items: Employee[];
  count: number;
}

export interface FindByIDsEmployeesResponse {
  items: Record<string, Employee>;
}

export async function findEmployeesByIDs(ids: string[]): Promise<FindByIDsEmployeesResponse> {
  return apiPost<FindByIDsEmployeesResponse>('/api/employees/find-by-ids', { ids });
}

/** Роли, которые можно назначить сотруднику через API (не администратор компании). */
export type AssignableMiniappRole = 'manager' | 'employee';

export const ASSIGNABLE_MINIAPP_ROLES: AssignableMiniappRole[] = ['manager', 'employee'];

/** Подписи для отображения miniappRole (в т.ч. устаревшие/системные значения). */
export type DisplayMiniappRole = 'administrator' | 'manager' | 'employee';

export const ROLE_LABELS: Record<DisplayMiniappRole, string> = {
  administrator: 'Администратор',
  manager: 'Менеджер',
  employee: 'Сотрудник',
};

/** Подписи пунктов контекстного меню назначения роли (как в основной системе). */
export const ASSIGN_ROLE_MENU_LABELS: Record<AssignableMiniappRole, string> = {
  manager: 'Назначить менеджером',
  employee: 'Назначить сотрудником',
};

export async function findEmployees(params: FindEmployeesParams = {}): Promise<FindEmployeesResponse> {
  return apiPost<FindEmployeesResponse>('/api/employees/find', {
    search: params.search ?? '',
    page: params.page ?? 1,
    itemsPerPage: params.itemsPerPage ?? 20,
  });
}

export async function assignRole(employeeId: string, role: AssignableMiniappRole): Promise<void> {
  await apiPostNoContent('/api/employees/assign-role', { employeeId, role });
}

export async function removeRole(employeeId: string, role: AssignableMiniappRole): Promise<void> {
  await apiPostNoContent('/api/employees/remove-role', { employeeId, role });
}
